document.getElementById('sort-articles').addEventListener('change', function() {
    sortArticles(this.value);
});

function sortArticles(sortOption) {
    const container = document.querySelector('.blog-grid');
    const articles = Array.from(container.querySelectorAll('.gb-article-card'));

    articles.sort(function(a, b) {
      switch (sortOption) {
        case 'date-desc':
          return new Date(b.getAttribute('data-date')) - new Date(a.getAttribute('data-date'));
        case 'date-asc':
          return new Date(a.getAttribute('data-date')) - new Date(b.getAttribute('data-date'));
        case 'title-asc':
          return a.getAttribute('data-title').localeCompare(b.getAttribute('data-title'));
        case 'title-desc':
          return b.getAttribute('data-title').localeCompare(a.getAttribute('data-title'));
      }
    });

    container.innerHTML = '';
    articles.forEach(function(article) {
      container.appendChild(article);
    });

    initializeLoadMore();
}

  function initializeLoadMore() {
    const container = document.querySelector('.blog-grid');
    const button = document.querySelector('.load');
    const articles = container.querySelectorAll('.gb-article-card');
    const loadMore = 12;

    articles.forEach(article => article.classList.add('d-none'));

    for (let i = 0; i < loadMore; i++) {
      if (articles[i]) {
        articles[i].classList.remove('d-none');
      }
    }

    if (articles.length <= loadMore) {
      button.style.display = 'none';
    } else {
      button.style.display = 'block';
    }

    button.addEventListener('click', function () {
      const hiddenArticles = container.querySelectorAll('.d-none');

      for (let i = 0; i < loadMore; i++) {
        if (hiddenArticles[i]) {
          hiddenArticles[i].classList.remove('d-none');
        }
      }

      if (container.querySelectorAll('.d-none').length === 0) {
        button.style.display = 'none';
      }
    });
  }

initializeLoadMore();